import React from 'react';

import MailIcon from '@mui/icons-material/Mail';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

/**
 * プロパティ
 */
export type Props = {
  /** クリック */
  onClick: () => void,
}

const EditEmailItem: React.FC<Props> = ({ onClick }) => (
  <ListItem
    button
    onClick={() => onClick()}
  >
    <ListItemIcon>
      <MailIcon />
    </ListItemIcon>
    <ListItemText primary="メールアドレス変更" />
  </ListItem>
);

export default EditEmailItem;
